<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      routerType: false,
    };
  },
  watch: {
    $route: {
      handler(val, oldval) {
        console.log(val);
        if (!['/', '/index/placeOrder/placeIndex'].includes(this.$route.path)) {
          this.routerType = true;
        } else {
          this.routerType = false;
        }
      },
    },
  },
  //方法集合
  methods: {},
  created() {
    if (!['/', '/index/placeOrder/placeIndex'].includes(this.$route.path)) {
      this.routerType = true;
    } else {
      this.routerType = false;
    }
  },
  mounted() { },
};
</script>

<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  /* background: url("/static/img/indexbg2.1309fb2.png") no-repeat;
  background-size: cover; */
}
.Count {
  background: url("/static/img/indexbg2.1309fb2.png") no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
}
.OldBackground {
  background: #ffffff;
  width: 100%;
  height: 100%;
}

body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
fieldset,
legend,
input,
button,
textarea,
p,
blockquote,
th,
td {
  margin: 0;
  padding: 0;
}
body {
  background: #fff;
  color: #555;
  font-size: 14px;
  font-family: Helvetica, "San Francisco", "Microsoft Yahei", "微软雅黑",
    Heiti SC;
  min-width: 1140px;
}
td,
th,
caption {
  font-size: 14px;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: normal;
  font-size: 100%;
}
address,
caption,
cite,
code,
dfn,
em,
strong,
th,
var {
  font-style: normal;
  font-weight: normal;
}
a {
  color: #555;
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
img {
  border: none;
}
ol,
ul,
li {
  list-style: none;
}
input,
textarea,
select,
button {
  font: 14px Verdana, Helvetica, Arial, sans-serif;
}
table {
  border-collapse: collapse;
}
html {
  overflow-y: scroll;
}

.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1;
}

/* 阴影 */
.table-goods-cover {
  width: 60px;
  height: 60px;
}
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  background-color: white;
}
::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 0px white;
  -webkit-box-shadow: inset 0 0 0px white;
  background-color: rgb(193, 193, 193);
  /*滚动条的背景颜色*/
  border-radius: 20px;
}
* {
  scrollbar-color: rgb(193, 193, 193) white; /* 滑块颜色  滚动条背景颜色 */
  scrollbar-width: thin; /* 滚动条宽度有三种：thin、auto、none */
}
.el-dialog {
  border-radius: 10px;
}
.el-table {
  border-radius: 10px;
}
.el-tabs__nav {
  transform: translateX(32px) !important;
}

.el-table td,
.el-table th {
  padding: 2px 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue